/**
 * 新增医学公式配置
 * 自动生成，请勿手动修改
 * 生成时间: 2025/12/15 13:34:57
 */

// 工具类型枚举
export const TOOL_TYPES_NEW = {
  SODIUMDEFICIT: 12,  // 低钠血症钠缺失计算公式
  SODIUMSALINE: 34,  // 低钠血症时补生理盐水
  MVVFEV1: 35,  // 动脉血气分析、肺最大通气量与肺功能的关系
  PEDIATRICMOTOR: 36,  // 小儿各年龄动作及行为发育
  PEDIATRICLANGUAGE: 37,  // 小儿各年龄语言发育
  PEDIATRICSOCIAL: 38,  // 小儿各年龄早期社会行为
  PEDIATRICTTOOTH: 39,  // 小儿出牙顺序
  DUKECRITERIA: 40,  // Duke诊断标准（感染性心内膜炎的诊断标准）
  BRAUNWALD: 41,  // 不稳定型心绞痛Braunwald分级
  HEMODYNAMIC: 42,  // 常见血流动力学检测参数及正常范围
  DEBAKEY: 43,  // DeBakey 分型(基于撕裂口位置和累及范围的解剖分类)
  FORRESTER: 44,  // Forrester 分级
  CARDIAC: 45,  // Framingham慢性心力衰竭诊断标准
  GORLIN: 46,  // Gorlin 公式
  GRADINGARTERIAL: 47,  // 冠状动脉狭窄分级
  INDEXBLOOD: 48,  // 踝肱血压指数
  DEFICGRADIBLOOD: 49,  // 急性下肢缺血分级
  JXFSRJONESZD: 50,  // 急性风湿热Jones诊断标准
  KILLIP: 51,  // Killip分级
  MBSCL: 52,  // 每搏输出量
  GRADINGCARDIAC: 53,  // NYHA心功能分级
  SIRSZDBZ: 54,  // SIRS诊断标准
  STANFORD: 55,  // Stanford 分型
  GRADIARTERPULMO: 56,  // WHO - FC 肺动脉高压功能分级
  GRADINGCARDIAC_1: 57,  // 心绞痛分级
  CARDIAC_1: 58,  // 心输出量（Fick）
  CARDIAC_2: 59,  // 心输出量（超声）
  BLOOD: 60,  // 血压水平的定义和分类标准
  HBA1C: 61,  // HbA1c换算
  URINEGLUCOSE: 62,  // 糖尿病视网膜病变国际临床分类法
  URINEGLUCOSE_1: 63,  // 妊娠期糖尿病 GDM 诊断标准
  GRADIURINEGLUCO: 64,  // 糖尿病足Wagner分级法
  URINE: 65,  // 微量白蛋白尿
  GRADING: 66,  // 改良呼吸困难分级
  GOLD: 67,  // GOLD分级
  HENDERSONHASSEL: 68,  // Henderson-Hasselbalch
  LIGHT: 69,  // Light标准
  HGZFD: 70,  // 喉梗阻分度
  INDEX: 71,  // 浅快呼吸指数
  RATIO: 72,  // V/Q比
  BARNETT: 73,  // Barnett分型
  CHIARI: 74,  // Chiari 畸形分型
  GRADING_1: 75,  // 改良 Ashworth 分级评定标准
  JNDTLCTGZ: 76,  // 加拿大头颅CT规则
  JSXKHJSZDDJB: 77,  // 脊髓休克和脊髓震荡的鉴别
  GRADING_2: 78,  // 肌力分级
  HPYLORIGRDZD: 79,  // H.pylori 感染的诊断标准
  HPYLORIGRDGC: 80,  // H.pylori 感染的根除标准
  ZTDBBHD: 81,  // 转铁蛋白饱和度
  ONCOLOGY_GRADING: 82,  // 未成熟畸胎瘤分级方法
  OBSTETRICS_BTRSZSDGDGDJ: 83,  // 不同妊娠周数的宫底高度及子宫长度
  TRAUMA_OTTAWAXGJGZZ: 84,  // Ottawa膝关节骨折诊断规则
  TRAUMA_GRADING: 85,  // 三度四分化（烧伤分度分级）
  TRAUMA_SSMJ: 86,  // 烧伤面积
  TRAUMA_PJDWT: 87,  // 皮节定位图
  ANESTHESIOLOGY_CORMACK: 88,  // Cormack分级
  ENDOCRINOLOGY_BLOODGLUCOSE: 89,  // 高渗性高血糖状态(HHS)实验室诊断标准
  ENDOCRINOLOGY_GRADING: 90,  // Graves 眼病分级标准
  HEPATOLOGY_GRADINGHEPATIC: 91,  // AAST（肝损伤分级）
  HEMATOLOGY_RATIO: 92,  // 胆红素/白蛋白比值
  RHEUMATOLOGY_BSBGJYJBZ: 93,  // 白塞病国际研究标准
  RHEUMATOLOGY_RENAL: 94,  // 狼疮性肾炎分型（ISN/RPS, 2003）
  RHEUMATOLOGY_LFSGJYXXFLBZ: 95,  // 类风湿关节炎X线分类标准
  RHEUMATOLOGY_LFSGJYZDBZAC1987: 96,  // 类风湿关节炎诊断标准（ACR, 1987）
  RHEUMATOLOGY_QZXJZYZDBZ: 97,  // 强直性脊柱炎诊断标准
  ORTHO_BADOMONTEGGIA: 98,  // Bado分型（Monteggia骨折）
  ELECTROLYTE_HENDERSONHASSEL: 99,  // Henderson-Hasselbalch
}

// 通用科室公式 (treatment)
export const NEW_FORMULA_TOOLS_TREATMENT_GENERAL = [
  {
    toolType: TOOL_TYPES_NEW.SODIUMDEFICIT,
    title: '低钠血症钠缺失计算公式',
    category: 'treatment/general',
    categoryName: '通用',
    abbreviation: 'snsf',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/general?type=snsf',
    routerPath: '/tools/formula/treatment/general?type=snsf',
    miniPath: '/pages/tools/formula/treatment/general?type=snsf',
    description: '低钠血症治疗计算',
    formulaData: {
          "formula": "",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.SODIUMSALINE,
    title: '低钠血症时补生理盐水',
    category: 'treatment/general',
    categoryName: '通用',
    abbreviation: 'sodiumsaline',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/general?type=sodiumsaline',
    routerPath: '/tools/formula/treatment/general?type=sodiumsaline',
    miniPath: '/pages/tools/formula/treatment/general?type=sodiumsaline',
    description: '低钠血症时补生理盐水',
    formulaData: {
          "formula": "生理盐水（ml）= [142-患者血Na+(mmol/L)] ×体重（kg）×3.888 （男性为3.888，女性为3.311）；",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "用于计算纠正低钠血症所需的生理盐水输注量。适用于轻中度低钠血症。重度低钠可能需要高渗盐水（3% NaCl含钠513 mmol/L）。\n3%NaCl （ml）= [142-患者血Na+(mmol/L)] ×体重（kg）×1.1666 （男性为1.1666，女性为0.993）；\n5% NaCl （ml）= [142-患者血Na+(mmol/L)] ×体重（kg）×0.7 （男性为0.7，女性为0.596）。",
          "reference": "[1]苏树德.对各种补钠公式的见解[J].右江医学,1985(03):22-25.\n[2]汤生洪.关于低血钠补钠代谢性酸中毒补碱公式的探讨[J].医师进修杂志,1993(05):35-36.\n[3]Adrogué HJ, Madias NE. Hyponatremia. N Engl J Med. 2000;342(21):1581-1589.",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.ELECTROLYTE_HENDERSONHASSEL,
    title: 'Henderson-Hasselbalch',
    category: 'treatment/general',
    categoryName: '通用',
    abbreviation: 'hendersonhassel',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/general?type=hendersonhassel',
    routerPath: '/tools/formula/treatment/general?type=hendersonhassel',
    miniPath: '/pages/tools/formula/treatment/general?type=hendersonhassel',
    description: 'Henderson-Hasselbalch',
    formulaData: {
          "formula": "pH = 6.1 + log([HCO₃⁻] / (0.03 × PaCO₂))\n或：pH = pKa + log([HCO₃⁻] / [H₂CO₃])",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "pH：血液酸碱度\npKa：碳酸的解离常数，6.1\nHCO₃⁻：血浆碳酸氢根浓度，mmol/L\nPaCO₂：动脉血二氧化碳分压，mmHg\n0.03：CO₂溶解系数\n正常动脉血气：\n  pH：7.35-7.45\n  PaCO₂：35-45 mmHg\n  HCO₃⁻：22-26 mmol/L\n酸中毒：pH <7.35\n碱中毒：pH >7.45\n描述pH、HCO₃⁻和PaCO₂之间关系的经典方程。用于理解酸碱平衡机制和血气分析。可计算任一参数当其他两个已知时。临床常用于判断代谢性或呼吸性酸碱失衡。",
          "reference": "",
          "description": ""
    }
  },
]

// 儿科学科室公式 (treatment)
export const NEW_FORMULA_TOOLS_TREATMENT_PEDIATRICS = [
  {
    toolType: TOOL_TYPES_NEW.PEDIATRICMOTOR,
    title: '小儿各年龄动作及行为发育',
    category: 'treatment/pediatrics',
    categoryName: '儿科疾病',
    abbreviation: 'pediatricmotor',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/pediatrics?type=pediatricmotor',
    routerPath: '/tools/formula/treatment/pediatrics?type=pediatricmotor',
    miniPath: '/pages/tools/formula/treatment/pediatrics?type=pediatricmotor',
    description: '小儿各年龄动作及行为发育',
    formulaData: {
          "formula": "1.平衡与大运动：\n(1)抬头:新生儿俯卧时能抬头1~2秒;3 个月时抬头较稳;4个月时抬头很稳。\n(2)坐:6个月时能双手向前撑住独坐;8个月时能坐稳。\n(3)翻身:7个月时能有意识地从仰卧位翻身至俯卧位,然后从俯卧位翻至仰卧位。\n(4)爬:应从3~4个月时开始训练,8~9个月可用双上肢向前爬。\n(5)站、走、跳:11个月时可独自站立片刻:15个月可独自走稳:24个月时可双足并跳:30个月时\n会独足跳。\n2.细动作 3~4个月握持反射消失之后手指可以活动;6~7个月时出现换手与捏、敲等探索性动作:9~10个月时可用拇、示指拾物,喜撕纸:12~15个月时学会用匙,乱涂画:18个月时能叠2~3块方积木:2岁时可叠6~7块方积木,会翻书。",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "",
          "reference": "王卫平,孙琨,常立文,等.（2018）.儿科学（第九版）[M].北京：人民卫生出版社。",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.PEDIATRICLANGUAGE,
    title: '小儿各年龄语言发育',
    category: 'treatment/pediatrics',
    categoryName: '儿科疾病',
    abbreviation: 'pediatriclanguage',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/pediatrics?type=pediatriclanguage',
    routerPath: '/tools/formula/treatment/pediatrics?type=pediatriclanguage',
    miniPath: '/pages/tools/formula/treatment/pediatrics?type=pediatriclanguage',
    description: '小儿各年龄语言发育',
    formulaData: {
          "formula": "新生儿已会哭叫,\n3~4个月咿呀发音;\n6~7月龄时能听懂自己的名字;\n12月龄时能说简单的单词,如“再见”“没了”。\n18月龄时能用15~20个字,指认并说出家庭主要成员的称谓;\n24月龄时能指出简单的人、物名和图片；\n到3岁时能指认许多物品名,并说由2~3个字组成的短句;\n4岁时能讲述简单的故事情节。",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "",
          "reference": "王卫平,孙琨,常立文,等.（2018）.儿科学（第九版）[M].北京：人民卫生出版社。",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.PEDIATRICSOCIAL,
    title: '小儿各年龄早期社会行为',
    category: 'treatment/pediatrics',
    categoryName: '儿科疾病',
    abbreviation: 'pediatricsocial',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/pediatrics?type=pediatricsocial',
    routerPath: '/tools/formula/treatment/pediatrics?type=pediatricsocial',
    miniPath: '/pages/tools/formula/treatment/pediatrics?type=pediatricsocial',
    description: '小儿各年龄早期社会行为',
    formulaData: {
          "formula": "早期的社会行为 2~3个月时小儿以笑、停止啼哭等行为,以眼神和发音表示认识父母;\n3~4个月的婴儿开始出现社会反应性的大笑;\n7~8个月的小儿可表现出认生、对发声玩具感兴趣等;\n9~12个月时是认生的高峰;\n12~13个月小儿喜欢玩变戏法和躲猫猫游戏;\n18个月时逐渐有自我控制能力,成人在附近时可独自玩要很久;\n2岁时不再认生,易与父母分开;\n3岁后可与小朋友做游戏。",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "",
          "reference": "王卫平,孙琨,常立文,等.（2018）.儿科学（第九版）[M].北京：人民卫生出版社。",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.PEDIATRICTTOOTH,
    title: '小儿出牙顺序',
    category: 'treatment/pediatrics',
    categoryName: '儿科疾病',
    abbreviation: 'pediatricttooth',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/pediatrics?type=pediatricttooth',
    routerPath: '/tools/formula/treatment/pediatrics?type=pediatricttooth',
    miniPath: '/pages/tools/formula/treatment/pediatrics?type=pediatricttooth',
    description: '小儿出牙顺序',
    formulaData: {
          "formula": "牙齿的生长与骨骼有一定关系,但因胚胎来源不完全相同,牙齿与骨骼的生长不完全平行。\n出生时乳牙已骨化,乳牙牙孢隐藏在颌骨中,被牙龈覆盖;恒牙的骨化从新生儿期开始,18~24个月时第三恒臼齿已骨化。\n人一生有乳牙(共20个)和恒牙(共28~32个)两副牙齿。生后4~10个月乳牙开始萌出,13个月后未萌出者为乳牙萌出延迟。\n乳牙萌出顺序一般为下颌先于上颌、自前向后,大多于3岁前出齐（如图所示）。\n乳牙萌出时间及顺序个体差异较大,与遗传、内分泌、食物性状有关。",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "",
          "reference": "王卫平,孙琨,常立文,等.（2018）.儿科学（第九版）[M].北京：人民卫生出版社。",
          "description": ""
    }
  },
]

// 心血管科室公式 (treatment)
export const NEW_FORMULA_TOOLS_TREATMENT_CARDIO = [
  {
    toolType: TOOL_TYPES_NEW.DUKECRITERIA,
    title: 'Duke诊断标准（感染性心内膜炎的诊断标准）',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'dukecriteria',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=dukecriteria',
    routerPath: '/tools/formula/treatment/cardio?type=dukecriteria',
    miniPath: '/pages/tools/formula/treatment/cardio?type=dukecriteria',
    description: 'Duke诊断标准（感染性心内膜炎的诊断标准）',
    formulaData: {
          "formula": "Duke标准（感染性心内膜炎诊断）：\n主要标准：\n  1.血培养阳性（典型病原菌2次或持续阳性）\n  2.心内膜受累证据（超声心动图或新发瓣膜反流）\n次要标准：\n  1.易感因素（心脏病史、静脉药瘾）\n  2.发热≥38°C\n  3.血管现象（栓塞、感染性动脉瘤等）\n  4.免疫现象（肾小球肾炎、Osler结节等）\n  5.微生物学证据（不符合主要标准）",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "Duke标准诊断分类：\n  确诊：符合主要标准2项或主要1项+次要3项或次要5项\n  拟诊：主要1项+次要1-2项或次要3-4项\n  排除：有其他诊断或治疗≤4天症状消失或不符合拟诊标准\n感染性心内膜炎（IE）的国际通用诊断标准。敏感性80%，特异性99%。结合血培养和超声心动图检查。早期诊断困难，需反复评估。高度怀疑IE时即使不符合Duke标准也需积极治疗。",
          "reference": "[1]Durack DT, Lukes AS, Bright DK. New criteria for diagnosis of infective endocarditis: utilization of specific echocardiographic findings. Duke Endocarditis Service. Am J Med. 1994;96(3):200-209. doi:10.1016/0002-9343(94)90143-0IF: 5.3 Q1\n[2]",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.BRAUNWALD,
    title: '不稳定型心绞痛Braunwald分级',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'braunwald',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=braunwald',
    routerPath: '/tools/formula/treatment/cardio?type=braunwald',
    miniPath: '/pages/tools/formula/treatment/cardio?type=braunwald',
    description: '不稳定型心绞痛Braunwald分级',
    formulaData: {
          "formula": "严重程度:\n- I: 新发/恶化 (2月内)，无静息痛\n- II: 亚急性静息痛 (1月内，但48h内无)\n- III: 急性静息痛 (48h内)\n\n临床环境:\n- A: 继发性 (贫血/感染/甲亢)xain\n- B: 原发性 (无心梗外因素)\n- C: 心梗后 (2周内)",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "用于不稳定型心绞痛 (UA) 的危险分层和预后评估，指导是否需要紧急介入治疗。\n风险分层:\n- ⅢB (48h内静息痛+原发): 高危\n- ⅢC (48h内静息痛+梗后): 极高危\n- I类: 相对低危",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.HEMODYNAMIC,
    title: '常见血流动力学检测参数及正常范围',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'hemodynamic',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=hemodynamic',
    routerPath: '/tools/formula/treatment/cardio?type=hemodynamic',
    miniPath: '/pages/tools/formula/treatment/cardio?type=hemodynamic',
    description: '常见血流动力学检测参数及正常范围',
    formulaData: {
          "formula": "正常值:\n- CVP: 2-6 mmHg (或 5-12 cmH2O)\n- PCWP: 6-12 mmHg\n- CI: 2.5-4.0 L/min/m²\n- SVR: 800-1200 dynes·sec/cm⁵\nCVP: 中心静脉压\nPCWP: 肺毛细血管楔压\nCI: 心指数\nSVR: 体循环血管阻力",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "用于ICU重症患者（如休克、心衰）的血流动力学监测，鉴别休克类型（如低血容量性 vs 分布性 vs 心源性）。",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.DEBAKEY,
    title: 'DeBakey 分型(基于撕裂口位置和累及范围的解剖分类)',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'debakey',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=debakey',
    routerPath: '/tools/formula/treatment/cardio?type=debakey',
    miniPath: '/pages/tools/formula/treatment/cardio?type=debakey',
    description: 'DeBakey 分型(基于撕裂口位置和累及范围的解剖分类)',
    formulaData: {
          "formula": "I型: 原发破口在升主动脉，累及升主动脉和降主动脉\nII型: 原发破口在升主动脉，仅累及升主动脉\nIII型: 原发破口在降主动脉 (锁骨下动脉远端)",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "分类判读:\n- I型 & II型 (Stanford A型): 外科急诊手术适应症\n- III型 (Stanford B型): 通常首选药物保守治疗或血管内支架 (TEVAR)",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.FORRESTER,
    title: 'Forrester 分级',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'forrester',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=forrester',
    routerPath: '/tools/formula/treatment/cardio?type=forrester',
    miniPath: '/pages/tools/formula/treatment/cardio?type=forrester',
    description: 'Forrester 分级',
    formulaData: {
          "formula": "I型 (正常): CI > 2.2, PCWP < 18. 死亡率 <3%.\nII型 (肺充血): CI > 2.2, PCWP > 18. 需利尿/扩血管.\nIII型 (低灌注/休克): CI < 2.2, PCWP < 18. 需补液.\nIV型 (充血+休克): CI < 2.2, PCWP > 18. 死亡率 >50%, 需正性肌力药/IABP.",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "CI: 心指数 (Cardiac Index), 界值 2.2 L/min/m²\nPCWP: 肺毛细血管楔压, 界值 18 mmHg\n急性心肌梗死泵衰竭的经典血流动力学分型，指导治疗方向（利尿 vs 补液 vs 强心）。",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.CARDIAC,
    title: 'Framingham慢性心力衰竭诊断标准',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'cardiac',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=cardiac',
    routerPath: '/tools/formula/treatment/cardio?type=cardiac',
    miniPath: '/pages/tools/formula/treatment/cardio?type=cardiac',
    description: 'Framingham慢性心力衰竭诊断标准',
    formulaData: {
          "formula": "诊断需满足: 2个主要标准 或 1个主要+2个次要标准\n主要标准: 夜间阵发性呼吸困难, 颈静脉怒张, 肺啰音, 心脏扩大, 急性肺水肿, S3奔马律, 静脉压升高, 肝颈静脉回流征阳性.\n次要标准: 踝部水肿, 夜间咳嗽, 活动后呼吸困难, 肝大, 胸腔积液, 肺活量降低, 心率>120.",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "流行病学和临床常用的慢性心力衰竭临床诊断标准，特异性较高。",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.GORLIN,
    title: 'Gorlin 公式',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'gorlin',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=gorlin',
    routerPath: '/tools/formula/treatment/cardio?type=gorlin',
    miniPath: '/pages/tools/formula/treatment/cardio?type=gorlin',
    description: 'Gorlin 公式',
    formulaData: {
          "formula": "瓣膜面积 (cm²) = CO / (HR × SEP × 44.3 × √ΔP)",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "心导管检查计算瓣口面积的金标准公式。尤其用于评估瓣膜狭窄程度。\nCO: 心输出量 (mL/min)\nHR: 心率 (bpm)\nSEP: 收缩/舒张射血期 (sec/beat)\nΔP: 跨瓣压差平均值 (mmHg)\n44.3: 经验常数\n主动脉瓣狭窄 (AS) 严重程度:\n- 轻度: > 1.5 cm²\n- 中度: 1.0 - 1.5 cm²\n- 重度: < 1.0 cm²\n\n二尖瓣狭窄 (MS):\n- 轻度: > 1.5 cm²\n- 中度: 1.0 - 1.5 cm²\n- 重度: < 1.0 cm²",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.GRADINGARTERIAL,
    title: '冠状动脉狭窄分级',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'gradingarterial',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=gradingarterial',
    routerPath: '/tools/formula/treatment/cardio?type=gradingarterial',
    miniPath: '/pages/tools/formula/treatment/cardio?type=gradingarterial',
    description: '冠状动脉狭窄分级',
    formulaData: {
          "formula": "分级标准:\n- 0级: 正常 (0%)\n- 1级: 轻微 (1-24%)\n- 2级: 轻度 (25-49%)\n- 3级: 中度 (50-69%)\n- 4级: 重度 (70-99%) 或 左主干 >50%\n- 5级: 完全闭塞 (100%)",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "标准化报告冠状动脉CTA或造影结果。≥50% (3级以上) 通常被认为具有血流动力学意义的狭窄（阻塞性冠心病）。",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.INDEXBLOOD,
    title: '踝肱血压指数',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'indexblood',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=indexblood',
    routerPath: '/tools/formula/treatment/cardio?type=indexblood',
    miniPath: '/pages/tools/formula/treatment/cardio?type=indexblood',
    description: '踝肱血压指数',
    formulaData: {
          "formula": "ABI = 踝部收缩压 (高值) / 上臂收缩压 (高值)\n测量双侧上臂和双侧踝部(胫后/足背)收缩压，取较高值。",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "诊断外周动脉疾病 (PAD) 的首选无创检查。\n判读:\n- >1.30: 血管钙化 (不可靠)\n- 0.90-1.30: 正常\n- 0.60-0.89: 轻度阻塞 (跛行)\n- 0.40-0.59: 中度阻塞\n- <0.40: 重度阻塞 (静息痛/溃疡)",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.DEFICGRADIBLOOD,
    title: '急性下肢缺血分级',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'deficgradiblood',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=deficgradiblood',
    routerPath: '/tools/formula/treatment/cardio?type=deficgradiblood',
    miniPath: '/pages/tools/formula/treatment/cardio?type=deficgradiblood',
    description: '急性下肢缺血分级',
    formulaData: {
          "formula": "I类：肢体可存活\nIIa：肢体边缘受威胁(感觉轻度缺失)\nIIb：立即受威胁(感觉缺失+运动无力)\nIII：肢体坏死(感觉运动丧失)",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "评估急性肢体缺血 (ALI) 严重程度及保肢可能性。\n治疗决策:\n- I级: 抗凝\n- IIa级: 紧急血管造影+血运重建\n- IIb级: 急诊血运重建\n- III级: 截肢",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.JXFSRJONESZD,
    title: '急性风湿热Jones诊断标准',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'jxfsrjoneszd',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=jxfsrjoneszd',
    routerPath: '/tools/formula/treatment/cardio?type=jxfsrjoneszd',
    miniPath: '/pages/tools/formula/treatment/cardio?type=jxfsrjoneszd',
    description: '急性风湿热Jones诊断标准',
    formulaData: {
          "formula": "Jones诊断标准：主要表现2项或主要1项+次要2项\n主要表现：心脏炎、游走性多关节炎、舞蹈病、皮下结节、环形红斑\n次要表现：发热、关节痛、ESR↑或CRP↑、心电图PR间期延长、既往风湿热史",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "风湿热诊断的经典标准，用于早期识别和治疗。\n确诊需链球菌感染证据+符合Jones标准",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.KILLIP,
    title: 'Killip分级',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'killip',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=killip',
    routerPath: '/tools/formula/treatment/cardio?type=killip',
    miniPath: '/pages/tools/formula/treatment/cardio?type=killip',
    description: 'Killip分级',
    formulaData: {
          "formula": "Killip心力衰竭分级（用于急性心肌梗死）：\nKillip I级：无心力衰竭征象，无肺部啰音和第三心音\nKillip II级：轻至中度心力衰竭，肺部啰音范围<50%肺野，可有第三心音\nKillip III级：重度心力衰竭（急性肺水肿），肺部啰音范围>50%肺野\nKillip IV级：心源性休克，血压<90mmHg，有周围低灌注表现",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "专门用于急性心肌梗死患者的心力衰竭严重程度评估和预后判断。基于简单的临床体征即可快速分级。指导紧急治疗策略（如血运重建、机械支持等）。\n院内死亡率：\nKillip I级：6%\nKillip II级：17%\nKillip III级：38%\nKillip IV级：81%\n分级越高，预后越差",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.MBSCL,
    title: '每搏输出量',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'mbscl',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=mbscl',
    routerPath: '/tools/formula/treatment/cardio?type=mbscl',
    miniPath: '/pages/tools/formula/treatment/cardio?type=mbscl',
    description: '每搏输出量',
    formulaData: {
          "formula": "SV = CO / HR × 1000\n或：SV = EDV - ESV",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "SV：每搏输出量(Stroke Volume)，单位mL/次\nCO：心输出量(Cardiac Output)，单位L/min\nHR：心率(Heart Rate)，单位次/min\nEDV：舒张末期容积，单位mL\nESV：收缩末期容积，单位mL\nSV正常值：\n  成人：60-100 mL/次\n  平均：70 mL/次\n每搏指数(SVI = SV/BSA)：\n  正常：33-47 mL/m²/次\n影响因素：前负荷、后负荷、心肌收缩力",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.GRADINGCARDIAC,
    title: 'NYHA心功能分级',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'gradingcardiac',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=gradingcardiac',
    routerPath: '/tools/formula/treatment/cardio?type=gradingcardiac',
    miniPath: '/pages/tools/formula/treatment/cardio?type=gradingcardiac',
    description: 'NYHA心功能分级',
    formulaData: {
          "formula": "NYHA心功能分级（纽约心脏协会分级）：\nⅠ级：患有心脏病但体力活动不受限制，日常活动不引起疲乏、心悸、呼吸困难或心绞痛\nⅡ级：体力活动轻度受限，休息时无症状，日常活动可引起疲乏、心悸、呼吸困难或心绞痛\nⅢ级：体力活动明显受限，休息时无症状，低于日常的活动即可引起上述症状\nⅣ级：不能从事任何体力活动，休息时也有心衰症状，活动后加重",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "I级：心功能正常\nII级：轻度心功能不全\nIII级：中度心功能不全\nIV级：重度心功能不全\n分级越高，预后越差，死亡率越高\n用于评估心力衰竭患者的症状严重程度和功能状态。简单易用，广泛应用于临床和研究。指导治疗强度和预后评估。常与ACC/AHA分期系统联合使用。注意：NYHA分级可随病情变化而改变。",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.SIRSZDBZ,
    title: 'SIRS诊断标准',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'sirszdbz',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=sirszdbz',
    routerPath: '/tools/formula/treatment/cardio?type=sirszdbz',
    miniPath: '/pages/tools/formula/treatment/cardio?type=sirszdbz',
    description: 'SIRS诊断标准',
    formulaData: {
          "formula": "符合以下2项或以上即诊断SIRS：\n1. 体温>38°C或<36°C\n2. 心率>90次/分\n3. 呼吸频率>20次/分或PaCO₂<32mmHg\n4. WBC>12×10⁹/L或<4×10⁹/L或未成熟细胞>10%",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "SIRS：全身炎症反应综合征\n体温：中心体温\n心率：每分钟心跳次数\n呼吸频率：每分钟呼吸次数\nPaCO₂：动脉血二氧化碳分压\nWBC：白细胞计数\n满足标准数量：\n  0-1项：无SIRS\n  2项：SIRS\n  3-4项：重度SIRS\nSIRS + 感染 = 脓毒症\nSIRS + 器官功能障碍 = 严重脓毒症",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.STANFORD,
    title: 'Stanford 分型',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'stanford',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=stanford',
    routerPath: '/tools/formula/treatment/cardio?type=stanford',
    miniPath: '/pages/tools/formula/treatment/cardio?type=stanford',
    description: 'Stanford 分型',
    formulaData: {
          "formula": "Stanford A型：夹层累及升主动脉（无论是否累及降主动脉）\nStanford B型：夹层仅累及降主动脉（不累计主动脉）",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "A型需急诊手术\nB型可内科治疗或择期手术\n主动脉夹层最常用分型，指导治疗策略。A型死亡率高，需紧急手术。",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.GRADIARTERPULMO,
    title: 'WHO - FC 肺动脉高压功能分级',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'gradiarterpulmo',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=gradiarterpulmo',
    routerPath: '/tools/formula/treatment/cardio?type=gradiarterpulmo',
    miniPath: '/pages/tools/formula/treatment/cardio?type=gradiarterpulmo',
    description: 'WHO - FC 肺动脉高压功能分级',
    formulaData: {
          "formula": "I级: 肺高压但无体力活动受限\nII级: 轻度受限，休息无不适，日常活动引起呼吸困难/胸痛\nIII级: 明显受限，休息无不适，轻微活动即引起症状\nIV级: 休息时有症状(呼吸困难/右心衰)，活动加重",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "肺动脉高压(PH)患者功能评估",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.GRADINGCARDIAC_1,
    title: '心绞痛分级',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'gradingcardiac_1',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=gradingcardiac_1',
    routerPath: '/tools/formula/treatment/cardio?type=gradingcardiac_1',
    miniPath: '/pages/tools/formula/treatment/cardio?type=gradingcardiac_1',
    description: '心绞痛分级',
    formulaData: {
          "formula": "I级: 一般活动无心绞痛 (强体力活动诱发)\nII级: 一般活动轻度受限 (快走/爬楼/餐后诱发)\nIII级: 一般活动明显受限 (平地行走/1层楼诱发)\nIV级: 轻微活动或静息即心绞痛",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.CARDIAC_1,
    title: '心输出量（Fick）',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'cardiac_1',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=cardiac_1',
    routerPath: '/tools/formula/treatment/cardio?type=cardiac_1',
    miniPath: '/pages/tools/formula/treatment/cardio?type=cardiac_1',
    description: '心输出量（Fick）',
    formulaData: {
          "formula": "CO = VO₂ / (CaO₂ - CvO₂)\nVO₂：氧耗量\nCaO₂：动脉血氧含量\nCvO₂：混合静脉血氧含量",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "CO：心输出量，L/min\nVO₂：氧耗量，mL/min\nCaO₂-CvO₂：动静脉氧含量差，mL/dL\n正常CO：4-8 L/min\n心指数CI=CO/BSA：2.5-4.0 L/min/m²",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.CARDIAC_2,
    title: '心输出量（超声）',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'cardiac_2',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=cardiac_2',
    routerPath: '/tools/formula/treatment/cardio?type=cardiac_2',
    miniPath: '/pages/tools/formula/treatment/cardio?type=cardiac_2',
    description: '心输出量（超声）',
    formulaData: {
          "formula": "CO = SV × HR\nSV = CSA × VTI = π(D/2)² × VTI",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "D: 流出道直径\nVTI: 速度时间积分\nHR: 心率\n正常CO: 4 - 8 L/min\n低排: 休克/心衰\n高排: 贫血/甲亢/感染",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.BLOOD,
    title: '血压水平的定义和分类标准',
    category: 'treatment/cardio',
    categoryName: '心血管疾病',
    abbreviation: 'blood',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/cardio?type=blood',
    routerPath: '/tools/formula/treatment/cardio?type=blood',
    miniPath: '/pages/tools/formula/treatment/cardio?type=blood',
    description: '血压水平的定义和分类标准',
    formulaData: {
          "formula": "收缩压(SBP) / 舒张压(DBP)\n正常血压: <120 / <80\n正常高值: 120-139 / 80-89\n高血压1级: 140-159 / 90-99\n高血压2级: 160-179 / 100-109\n高血压3级: ≥180 / ≥110\n单纯收缩期高血压: ≥140 / <90",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "",
          "reference": "",
          "description": ""
    }
  },
]

// 糖尿病科室公式 (treatment)
export const NEW_FORMULA_TOOLS_TREATMENT_DIABETES = [
  {
    toolType: TOOL_TYPES_NEW.HBA1C,
    title: 'HbA1c换算',
    category: 'treatment/diabetes',
    categoryName: '内分泌与代谢性疾病',
    abbreviation: 'hba1c',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/diabetes?type=hba1c',
    routerPath: '/tools/formula/treatment/diabetes?type=hba1c',
    miniPath: '/pages/tools/formula/treatment/diabetes?type=hba1c',
    description: 'HbA1c换算',
    formulaData: {
          "formula": "平均血糖(mmol/L) = (HbA1c% × 1.59) - 2.59\n或：平均血糖(mg/dL) = (HbA1c% × 28.7) - 46.7\nHbA1c国际单位换算：HbA1c(mmol/mol) = [HbA1c(%) - 2.15] × 10.929",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "HbA1c：糖化血红蛋白百分比(%)\n平均血糖：反映近2-3个月的平均血糖水平\nmmol/L：国际单位\nmg/dL：美国单位\nHbA1c正常值：4-6%\n糖尿病前期：5.7-6.4%\n糖尿病诊断标准：≥6.5%\n糖尿病控制目标：\n  一般患者：<7%\n  老年或并发症患者：<8%\n  年轻无并发症：<6.5%",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.URINEGLUCOSE,
    title: '糖尿病视网膜病变国际临床分类法',
    category: 'treatment/diabetes',
    categoryName: '内分泌与代谢性疾病',
    abbreviation: 'urineglucose',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/diabetes?type=urineglucose',
    routerPath: '/tools/formula/treatment/diabetes?type=urineglucose',
    miniPath: '/pages/tools/formula/treatment/diabetes?type=urineglucose',
    description: '糖尿病视网膜病变国际临床分类法',
    formulaData: {
          "formula": "1. 无DR\n2. 轻度NPDR: 仅有微动脉瘤\n3. 中度NPDR: 介于轻重之间\n4. 重度NPDR: 4-2-1法则 (4象限出血/2象限静脉串珠/1象限IRMA)\n5. PDR: 新生血管或玻璃体/视网膜前出血",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.URINEGLUCOSE_1,
    title: '妊娠期糖尿病 GDM 诊断标准',
    category: 'treatment/diabetes',
    categoryName: '内分泌与代谢性疾病',
    abbreviation: 'urineglucose_1',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/diabetes?type=urineglucose_1',
    routerPath: '/tools/formula/treatment/diabetes?type=urineglucose_1',
    miniPath: '/pages/tools/formula/treatment/diabetes?type=urineglucose_1',
    description: '妊娠期糖尿病 GDM 诊断标准',
    formulaData: {
          "formula": "75g OGTT：空腹≥5.1、1h≥10.0、2h≥8.5 mmol/L，任一项达标即诊断",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "OGTT：口服葡萄糖耐量试验\n孕24-28周筛查\n高危孕妇需早筛\n任一时间点血糖达标即诊断GDM",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.GRADIURINEGLUCO,
    title: '糖尿病足Wagner分级法',
    category: 'treatment/diabetes',
    categoryName: '内分泌与代谢性疾病',
    abbreviation: 'gradiurinegluco',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/diabetes?type=gradiurinegluco',
    routerPath: '/tools/formula/treatment/diabetes?type=gradiurinegluco',
    miniPath: '/pages/tools/formula/treatment/diabetes?type=gradiurinegluco',
    description: '糖尿病足Wagner分级法',
    formulaData: {
          "formula": "0级: 高危足, 无溃疡\n1级: 浅表溃疡\n2级: 深部溃疡 (达肌腱/骨), 无脓肿/骨髓炎\n3级: 深部溃疡 + 脓肿/骨髓炎\n4级: 局限性坏疽 (趾/足跟)\n5级: 全足坏疽",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "评估糖尿病足溃疡严重程度及截肢风险。\n治疗:\n- 3级以上通常需住院抗感染及外科干预 (截趾/截肢)。",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.URINE,
    title: '微量白蛋白尿',
    category: 'treatment/diabetes',
    categoryName: '内分泌与代谢性疾病',
    abbreviation: 'urine',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/diabetes?type=urine',
    routerPath: '/tools/formula/treatment/diabetes?type=urine',
    miniPath: '/pages/tools/formula/treatment/diabetes?type=urine',
    description: '微量白蛋白尿',
    formulaData: {
          "formula": "尿白蛋白/肌酐比值(mg/g或mg/mmol)",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "随机尿测定，避免24h尿收集\n<30 mg/g：正常\n30-300：微量白蛋白尿\n>300：大量白蛋白尿\n早期肾损害筛查，糖尿病/高血压随访",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.ENDOCRINOLOGY_BLOODGLUCOSE,
    title: '高渗性高血糖状态(HHS)实验室诊断标准',
    category: 'treatment/diabetes',
    categoryName: '内分泌与代谢性疾病',
    abbreviation: 'bloodglucose',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/diabetes?type=bloodglucose',
    routerPath: '/tools/formula/treatment/diabetes?type=bloodglucose',
    miniPath: '/pages/tools/formula/treatment/diabetes?type=bloodglucose',
    description: '高渗性高血糖状态(HHS)实验室诊断标准',
    formulaData: {
          "formula": "血糖>33.3 mmol/L\n有效渗透压>320 mOsm/kg\npH>7.30、HCO₃>15 mmol/L\n尿酮阴性或弱阳性\n意识改变",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "HHS诊断，与DKA鉴别",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.ENDOCRINOLOGY_GRADING,
    title: 'Graves 眼病分级标准',
    category: 'treatment/diabetes',
    categoryName: '内分泌与代谢性疾病',
    abbreviation: 'grading_1',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/diabetes?type=grading_1',
    routerPath: '/tools/formula/treatment/diabetes?type=grading_1',
    miniPath: '/pages/tools/formula/treatment/diabetes?type=grading_1',
    description: 'Graves 眼病分级标准',
    formulaData: {
          "formula": "0：无症状\n1：仅眼征\n2：软组织受累\n3：突眼\n4：眼肌受累\n5：角膜受累\n6：视力丧失",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "Graves眼病严重程度分级",
          "reference": "",
          "description": ""
    }
  },
]

// 呼吸科室公式 (treatment)
export const NEW_FORMULA_TOOLS_TREATMENT_RESP = [
  {
    toolType: TOOL_TYPES_NEW.MVVFEV1,
    title: '动脉血气分析、肺最大通气量与肺功能的关系',
    category: 'treatment/respiratory',
    categoryName: '呼吸系统疾病',
    abbreviation: 'mvvfev1',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/respiratory?type=mvvfev1',
    routerPath: '/tools/formula/treatment/respiratory?type=mvvfev1',
    miniPath: '/pages/tools/formula/treatment/respiratory?type=mvvfev1',
    description: '动脉血气分析、肺最大通气量与肺功能的关系',
    formulaData: {
          "formula": "MVV预计值(L/min) = FEV1(L) × 40",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "MVV：最大通气量\nFEV1：1秒用力呼气量\nMVV能反映受检者的呼吸系统的整体功能，是反映肺储备能力的很好指标。",
          "reference": "[1]中华医学会,中华医学会杂志社,中华医学会全科医学分会,et al.中国常规肺功能检查基层指南(2024年)[J].中华全科医师杂志, 2025, 24(02):121-137.DOI:10.3760/cma.j.cn114798-20240618-00555.",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.GRADING,
    title: '改良呼吸困难分级',
    category: 'treatment/respiratory',
    categoryName: '呼吸系统疾病',
    abbreviation: 'grading_2',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/respiratory?type=grading_2',
    routerPath: '/tools/formula/treatment/respiratory?type=grading_2',
    miniPath: '/pages/tools/formula/treatment/respiratory?type=grading_2',
    description: '改良呼吸困难分级',
    formulaData: {
          "formula": "mMRC呼吸困难分级（改良英国医学研究委员会）：\n0级：仅剧烈活动时气短\n1级：平地快步行走或爬缓坡时气短\n2级：因气短平地行走比同龄人慢或需停下休息\n3级：平地行走100米或数分钟后需停下喘气\n4级：因严重气短不能离开房间或穿衣时气短",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "mMRC分级判读：\n  0-1级：症状轻\n  ≥2级：症状显著\nCOPD综合评估中：\n  mMRC 0-1级为症状轻\n  mMRC ≥2级为症状重",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.GOLD,
    title: 'GOLD分级',
    category: 'treatment/respiratory',
    categoryName: '呼吸系统疾病',
    abbreviation: 'gold',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/respiratory?type=gold',
    routerPath: '/tools/formula/treatment/respiratory?type=gold',
    miniPath: '/pages/tools/formula/treatment/respiratory?type=gold',
    description: 'GOLD分级',
    formulaData: {
          "formula": "GOLD分级（COPD严重度分级）：\nGOLD 1（轻度）：FEV1 ≥80%预计值\nGOLD 2（中度）：50% ≤ FEV1 <80%预计值\nGOLD 3（重度）：30% ≤ FEV1 <50%预计值\nGOLD 4（极重度）：FEV1 <30%预计值\nFEV1：第1秒用力呼气容积",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "COPD诊断标准：\n  吸入支气管扩张剂后FEV1/FVC <0.70\n综合评估（GOLD ABCD）：\n  症状评估（mMRC或CAT评分）\n  急性加重史\n  肺功能分级\n评估COPD气流受限严重程度。GOLD 2017版采用ABCD综合评估系统，结合症状和急性加重风险。",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.HENDERSONHASSEL,
    title: 'Henderson-Hasselbalch',
    category: 'treatment/respiratory',
    categoryName: '呼吸系统疾病',
    abbreviation: 'hendersonhassel',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/respiratory?type=hendersonhassel',
    routerPath: '/tools/formula/treatment/respiratory?type=hendersonhassel',
    miniPath: '/pages/tools/formula/treatment/respiratory?type=hendersonhassel',
    description: 'Henderson-Hasselbalch',
    formulaData: {
          "formula": "pH = 6.1 + log([HCO₃⁻] / (0.03 × PaCO₂))\n或：pH = pKa + log([HCO₃⁻] / [H₂CO₃])",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "pH：血液酸碱度\npKa：碳酸的解离常数，6.1\nHCO₃⁻：血浆碳酸氢根浓度，mmol/L\nPaCO₂：动脉血二氧化碳分压，mmHg\n0.03：CO₂溶解系数\n正常动脉血气：\n  pH：7.35-7.45\n  PaCO₂：35-45 mmHg\n  HCO₃⁻：22-26 mmol/L\n酸中毒：pH <7.35\n碱中毒：pH >7.45\n描述pH、HCO₃⁻和PaCO₂之间关系的经典方程。用于理解酸碱平衡机制和血气分析。可计算任一参数当其他两个已知时。临床常用于判断代谢性或呼吸性酸碱失衡。",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.LIGHT,
    title: 'Light标准',
    category: 'treatment/respiratory',
    categoryName: '呼吸系统疾病',
    abbreviation: 'light',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/respiratory?type=light',
    routerPath: '/tools/formula/treatment/respiratory?type=light',
    miniPath: '/pages/tools/formula/treatment/respiratory?type=light',
    description: 'Light标准',
    formulaData: {
          "formula": "满足一条即为渗出液：\n胸液蛋白/血清蛋白>0.5\n胸液LDH/血清LDH>0.6\n胸液LDH>血清LDH正常上限2/3",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "全不满足：漏出液（心衰、肝硬化等）\n满足任一：渗出液（感染、肿瘤等）",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.HGZFD,
    title: '喉梗阻分度',
    category: 'treatment/respiratory',
    categoryName: '呼吸系统疾病',
    abbreviation: 'hgzfd',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/respiratory?type=hgzfd',
    routerPath: '/tools/formula/treatment/respiratory?type=hgzfd',
    miniPath: '/pages/tools/formula/treatment/respiratory?type=hgzfd',
    description: '喉梗阻分度',
    formulaData: {
          "formula": "I度: 活动后吸气性呼吸困难/喉鸣\nII度: 安静时有喉鸣/三凹征, 无缺氧\nIII度: 明显呼吸困难, 烦躁不安, 缺氧(发绀/心率快)\nIV度: 衰竭状态, 昏迷, 窒息",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "处置:\n- I-II度: 药物治疗 (激素/雾化)\n- III度: 严密监护, 准备气管切开/插管\n- IV度: 立即气管切开/插管",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.INDEX,
    title: '浅快呼吸指数',
    category: 'treatment/respiratory',
    categoryName: '呼吸系统疾病',
    abbreviation: 'index',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/respiratory?type=index',
    routerPath: '/tools/formula/treatment/respiratory?type=index',
    miniPath: '/pages/tools/formula/treatment/respiratory?type=index',
    description: '浅快呼吸指数',
    formulaData: {
          "formula": "RSBI = RR / VT",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "RSBI：浅快呼吸指数(Rapid Shallow Breathing Index)\nRR：呼吸频率，单位次/分\nVT：潮气量，单位L（注意单位！）\nRSBI判读：\n  <105：撤机成功可能性大\n  >105：撤机失败风险高\n  <80：撤机成功率>90%\n  >105：撤机成功率<20%\n注意：需在自主呼吸试验(SBT)时测量\n预测机械通气撤机成功率的最常用指标。在进行自主呼吸试验时测量，简单易行。RSBI越高表示呼吸越浅快，撤机失败风险越大。需结合其他指标综合判断。",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.RATIO,
    title: 'V/Q比',
    category: 'treatment/respiratory',
    categoryName: '呼吸系统疾病',
    abbreviation: 'ratio_1',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/respiratory?type=ratio_1',
    routerPath: '/tools/formula/treatment/respiratory?type=ratio_1',
    miniPath: '/pages/tools/formula/treatment/respiratory?type=ratio_1',
    description: 'V/Q比',
    formulaData: {
          "formula": "V/Q = 肺泡通气量 / 肺血流量",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "正常全肺V/Q约0.8\nV/Q↑：死腔通气↑\nV/Q↓：分流↑\n评估通气血流匹配，判断低氧原因",
          "reference": "",
          "description": ""
    }
  },
]

// 神经病学科室公式 (treatment)
export const NEW_FORMULA_TOOLS_TREATMENT_NEUROLOGY = [
  {
    toolType: TOOL_TYPES_NEW.BARNETT,
    title: 'Barnett分型',
    category: 'treatment/neurology',
    categoryName: '神经系统疾病',
    abbreviation: 'barnett',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/neurology?type=barnett',
    routerPath: '/tools/formula/treatment/neurology?type=barnett',
    miniPath: '/pages/tools/formula/treatment/neurology?type=barnett',
    description: 'Barnett分型',
    formulaData: {
          "formula": "I型：枕大孔区狭窄\nII型：伴脊髓空洞\nIII型：伴Chiari畸形",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "颅底凹陷分型，指导手术",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.CHIARI,
    title: 'Chiari 畸形分型',
    category: 'treatment/neurology',
    categoryName: '神经系统疾病',
    abbreviation: 'chiari',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/neurology?type=chiari',
    routerPath: '/tools/formula/treatment/neurology?type=chiari',
    miniPath: '/pages/tools/formula/treatment/neurology?type=chiari',
    description: 'Chiari 畸形分型',
    formulaData: {
          "formula": "I型：小脑扁桃体下疝\nII型：伴脊髓脊膜膨出\nIII型：伴枕部脑脊膜膨出\nIV型：小脑发育不全",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "I型最常见。\nChiari畸形分型，指导治疗",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.GRADING_1,
    title: '改良 Ashworth 分级评定标准',
    category: 'treatment/neurology',
    categoryName: '神经系统疾病',
    abbreviation: 'GRADING_1',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/neurology?type=grading_1',
    routerPath: '/tools/formula/treatment/neurology?type=grading_1',
    miniPath: '/pages/tools/formula/treatment/neurology?type=grading_1',
    description: '改良 Ashworth 分级评定标准',
    formulaData: {
          "formula": "0-无肌张力增高\n1-轻度增高\n1+-轻度增高，ROM后半段阻力\n2-中度增高，ROM大部分阻力\n3-重度增高，被动运动困难\n4-僵硬",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "评估痉挛状态，指导康复治疗和抗痉挛治疗",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.JNDTLCTGZ,
    title: '加拿大头颅CT规则',
    category: 'treatment/neurology',
    categoryName: '神经系统疾病',
    abbreviation: 'jndtlctgz',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/neurology?type=jndtlctgz',
    routerPath: '/tools/formula/treatment/neurology?type=jndtlctgz',
    miniPath: '/pages/tools/formula/treatment/neurology?type=jndtlctgz',
    description: '加拿大头颅CT规则',
    formulaData: {
          "formula": "高危（颅内出血）：GCS<15(2h后)、开放/凹陷骨折、颅底骨折征、呕吐≥2次、年龄≥65岁\n中危（脑损伤）：失忆>30min、危险机制",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "头部外伤CT适应证",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.JSXKHJSZDDJB,
    title: '脊髓休克和脊髓震荡的鉴别',
    category: 'treatment/neurology',
    categoryName: '神经系统疾病',
    abbreviation: 'jsxkhjszddjb',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/neurology?type=jsxkhjszddjb',
    routerPath: '/tools/formula/treatment/neurology?type=jsxkhjszddjb',
    miniPath: '/pages/tools/formula/treatment/neurology?type=jsxkhjszddjb',
    description: '脊髓休克和脊髓震荡的鉴别',
    formulaData: {
          "formula": "脊髓休克：完全性损伤，持续数周到数月，反射消失，不可逆\n脊髓震荡：可逆性功能障碍，数小时到数天恢复，反射可恢复",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "时间和可逆性是关键。\n脊髓损伤鉴别和预后",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.GRADING_2,
    title: '肌力分级',
    category: 'treatment/neurology',
    categoryName: '神经系统疾病',
    abbreviation: 'grading_2',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/neurology?type=grading_2',
    routerPath: '/tools/formula/treatment/neurology?type=grading_2',
    miniPath: '/pages/tools/formula/treatment/neurology?type=grading_2',
    description: '肌力分级',
    formulaData: {
          "formula": "0: 无收缩\n1: 仅有肌肉收缩 (无关节活动)\n2: 肢体能水平移动 (不能抗重力)\n3: 能抗重力抬离床面 (不能抗阻力)\n4: 能抗部分阻力\n5: 正常肌力",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "5级：正常\n4级：轻度减弱\n3级：中度减弱\n0-2级：重度减弱或瘫痪\n评估肌肉力量最常用方法，用于神经肌肉疾病评估、脑卒中康复、周围神经病等。",
          "reference": "",
          "description": ""
    }
  },
]

// 胃肠消化病学科室公式 (treatment)
export const NEW_FORMULA_TOOLS_TREATMENT_GASTRO = [
  {
    toolType: TOOL_TYPES_NEW.HPYLORIGRDZD,
    title: 'H.pylori 感染的诊断标准',
    category: 'treatment/gastroenterology',
    categoryName: '消化系统疾病',
    abbreviation: 'hpylorigrdzd',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/gastroenterology?type=hpylorigrdzd',
    routerPath: '/tools/formula/treatment/gastroenterology?type=hpylorigrdzd',
    miniPath: '/pages/tools/formula/treatment/gastroenterology?type=hpylorigrdzd',
    description: 'H.pylori 感染的诊断标准',
    formulaData: {
          "formula": "任一检测方法阳性即可诊断：\n侵入性：快速尿素酶试验、组织学、培养\n非侵入性：UBT、粪便抗原、血清学",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "Hp感染诊断",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.HPYLORIGRDGC,
    title: 'H.pylori 感染的根除标准',
    category: 'treatment/gastroenterology',
    categoryName: '消化系统疾病',
    abbreviation: 'hpylorigrdgc',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/gastroenterology?type=hpylorigrdgc',
    routerPath: '/tools/formula/treatment/gastroenterology?type=hpylorigrdgc',
    miniPath: '/pages/tools/formula/treatment/gastroenterology?type=hpylorigrdgc',
    description: 'H.pylori 感染的根除标准',
    formulaData: {
          "formula": "需停PPI至少2周、抗生素至少4周后检测\n首选¹³C/¹⁴C尿素呼气试验",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "Hp根除疗效判定",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.ZTDBBHD,
    title: '转铁蛋白饱和度',
    category: 'treatment/gastroenterology',
    categoryName: '消化系统疾病',
    abbreviation: 'ztdbbhd',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/gastroenterology?type=ztdbbhd',
    routerPath: '/tools/formula/treatment/gastroenterology?type=ztdbbhd',
    miniPath: '/pages/tools/formula/treatment/gastroenterology?type=ztdbbhd',
    description: '转铁蛋白饱和度',
    formulaData: {
          "formula": "TSAT(%) = (血清铁 / 总铁结合力) × 100%",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "TSAT：转铁蛋白饱和度\n血清铁：单位μmol/L或μg/dL\nTIBC：总铁结合力，单位同血清铁\nTSAT正常：20-50%\n<20%：缺铁\n>50%：铁超负荷\n评估铁代谢状态，诊断缺铁性贫血和铁过载。TSAT<20%+低SF：缺铁性贫血。",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.HEPATOLOGY_GRADINGHEPATIC,
    title: 'AAST（肝损伤分级）',
    category: 'treatment/gastroenterology',
    categoryName: '消化系统疾病',
    abbreviation: 'gradinghepatic',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/gastroenterology?type=gradinghepatic',
    routerPath: '/tools/formula/treatment/gastroenterology?type=gradinghepatic',
    miniPath: '/pages/tools/formula/treatment/gastroenterology?type=gradinghepatic',
    description: 'AAST（肝损伤分级）',
    formulaData: {
          "formula": "I: 被膜下血肿<10%, 裂伤<1cm\nII: 血肿10-50%, 裂伤1-3cm\nIII: 血肿>50%, 裂伤>3cm\nIV: 肝叶破裂/大血管伤\nV: 广泛破坏/肝静脉伤\nVI: 肝撕脱",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "指导创伤手术及保守治疗",
          "reference": "",
          "description": ""
    }
  },
]

// 肿瘤学科室公式 (treatment)
export const NEW_FORMULA_TOOLS_TREATMENT_ONCOLOGY = [
  {
    toolType: TOOL_TYPES_NEW.ONCOLOGY_GRADING,
    title: '未成熟畸胎瘤分级方法',
    category: 'treatment/oncology',
    categoryName: '肿瘤',
    abbreviation: 'grading',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/oncology?type=grading',
    routerPath: '/tools/formula/treatment/oncology?type=grading',
    miniPath: '/pages/tools/formula/treatment/oncology?type=grading',
    description: '未成熟畸胎瘤分级方法',
    formulaData: {
          "formula": "Ⅰ级：肿瘤内胚胎性神经组织灶稀少，占据每张切片不到1个低倍视野；\n    Ⅱ级：肿瘤内胚胎性神经组织灶中等量，即每张切片内1~3个低倍视野可找到；\n    Ⅲ级：每张切片内有4个低倍视野以上。",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "近来研究发现，未成熟性畸胎瘤的原因来自于不同的减数分裂错误，如第一次减数分裂中的不分离错误、第二次减数分裂中的不分离错误、成熟卵子的全基因组复制和2个卵子的融合等，会导致广泛的等位基因失衡、少量的体细胞突变和拷贝数改变。",
          "reference": "",
          "description": ""
    }
  },
]

// 产科科室公式 (treatment)
export const NEW_FORMULA_TOOLS_TREATMENT_OBSTETRICS = [
  {
    toolType: TOOL_TYPES_NEW.OBSTETRICS_BTRSZSDGDGDJ,
    title: '不同妊娠周数的宫底高度及子宫长度',
    category: 'treatment/obstetrics',
    categoryName: '产科疾病',
    abbreviation: 'btrszsdgdgdj',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/obstetrics?type=btrszsdgdgdj',
    routerPath: '/tools/formula/treatment/obstetrics?type=btrszsdgdgdj',
    miniPath: '/pages/tools/formula/treatment/obstetrics?type=btrszsdgdgdj',
    description: '不同妊娠周数的宫底高度及子宫长度',
    formulaData: {
          "formula": "12周：耻骨联合上\n16周：脐耻之间\n20周：脐下一横指\n24周：脐上一横指\n36周：剑突下\n40周：剑突下2-3横指",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "宫高(cm) ≈ 孕周数-3到+3",
          "reference": "",
          "description": ""
    }
  },
]

// 创伤医学科室公式 (treatment)
export const NEW_FORMULA_TOOLS_TREATMENT_TRAUMA = [
  {
    toolType: TOOL_TYPES_NEW.TRAUMA_OTTAWAXGJGZZ,
    title: 'Ottawa膝关节骨折诊断规则',
    category: 'treatment/trauma',
    categoryName: '急诊',
    abbreviation: 'ottawaxgjgzz',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/trauma?type=ottawaxgjgzz',
    routerPath: '/tools/formula/treatment/trauma?type=ottawaxgjgzz',
    miniPath: '/pages/tools/formula/treatment/trauma?type=ottawaxgjgzz',
    description: 'Ottawa膝关节骨折诊断规则',
    formulaData: {
          "formula": "年龄≥55岁\n孤立性髌骨压痛\n腓骨头压痛\n不能屈膝90°\n不能负重（行走4步）",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "膝关节外伤后是否需要摄片。\n任一项阳性：需X线，敏感性接近100%",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.TRAUMA_GRADING,
    title: '三度四分化（烧伤分度分级）',
    category: 'treatment/trauma',
    categoryName: '急诊',
    abbreviation: 'grading',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/trauma?type=grading',
    routerPath: '/tools/formula/treatment/trauma?type=grading',
    miniPath: '/pages/tools/formula/treatment/trauma?type=grading',
    description: '三度四分化（烧伤分度分级）',
    formulaData: {
          "formula": "I度：红斑，3-5天愈合\n浅II度：水疱，基底红润，<2周愈合\n深II度：基底苍白，2-4周愈合\nIII度：焦痂，需植皮",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "深II度及III度需手术",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.TRAUMA_SSMJ,
    title: '烧伤面积',
    category: 'treatment/trauma',
    categoryName: '急诊',
    abbreviation: 'ssmj',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/trauma?type=ssmj',
    routerPath: '/tools/formula/treatment/trauma?type=ssmj',
    miniPath: '/pages/tools/formula/treatment/trauma?type=ssmj',
    description: '烧伤面积',
    formulaData: {
          "formula": "成人：九分法\n头颈：头（3%）、面（3%）、颈（3%），9%*1=9%\n双上肢：双手（5%）、双前臂（6%）、双上臂（7%），9%*2=18%\n躯干：躯干前（13%）、躯干后（13%）、会阴（1%），9%*3=27%\n双下肢：双臀（5%）、双足（7%）、双小腿（13%）、双大腿（21%），9%*5+1=46%",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "烧伤面积分度：\n  轻度：<10%（II度）\n  中度：11-30%（II度）或III度<10%\n  重度：31-50%（II度）或III度11-20%，或Ⅱ度、Ⅲ度烧伤面积虽不到上述百分比,但已发生休克、合并较重的吸入性损伤和复合伤等。\n  特重度：烧伤>50%或III度>20%",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.TRAUMA_PJDWT,
    title: '皮节定位图',
    category: 'treatment/trauma',
    categoryName: '急诊',
    abbreviation: 'pjdwt',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/trauma?type=pjdwt',
    routerPath: '/tools/formula/treatment/trauma?type=pjdwt',
    miniPath: '/pages/tools/formula/treatment/trauma?type=pjdwt',
    description: '皮节定位图',
    formulaData: {
          "formula": "颈段（C1-C8）\nC2-C3：支配后脑勺、耳后及颈部皮肤。\nC4：肩部及锁骨区域。\nC5-C7：上肢外侧、前臂至拇指、食指和中指（如C6对应拇指背侧）。\nC8：小指、前臂内侧及手部尺侧。\n胸段（T1-T12）\nT1-T2：上胸部及腋窝附近。\nT4：乳头水平对应的胸壁区域。\nT10：脐部水平对应的腹部皮肤。\nT12：腹股沟及下腹部。\n腰段（L1-L5）\nL1-L2：大腿前侧及腹股沟外侧。\nL3：膝关节前方。\nL4：小腿内侧及足背内侧（如L4对应大脚趾内侧）。\nL5：小腿外侧、足背及第1-3趾。\n骶段（S1-S5）\nS1：足外侧、足底及小趾。\nS2-S3：大腿后侧、会阴部及臀部。\nS4-S5：肛门周围及生殖器区域。",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "用于脊髓损伤定位",
          "reference": "",
          "description": ""
    }
  },
]

// 麻醉学科室公式 (treatment)
export const NEW_FORMULA_TOOLS_TREATMENT_ANESTHESIOLOGY = [
  {
    toolType: TOOL_TYPES_NEW.ANESTHESIOLOGY_CORMACK,
    title: 'Cormack分级',
    category: 'treatment/anesthesiology',
    categoryName: '麻醉',
    abbreviation: 'cormack',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/anesthesiology?type=cormack',
    routerPath: '/tools/formula/treatment/anesthesiology?type=cormack',
    miniPath: '/pages/tools/formula/treatment/anesthesiology?type=cormack',
    description: 'Cormack分级',
    formulaData: {
          "formula": "I 级 (Grade I)：能完全看到声门（声门完全暴露）。\nII 级 (Grade II)：只能看到部分声门，通常是声门后缘或杓状软骨。\nIII 级 (Grade III)：只能看到会厌（Epiglottis），声门无法显示。\nIV 级 (Grade IV)：甚至看不到会厌，只能看到软腭。",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "",
          "reference": "",
          "description": ""
    }
  },
]

// 血液学科室公式 (treatment)
export const NEW_FORMULA_TOOLS_TREATMENT_HEMATOLOGY = [
  {
    toolType: TOOL_TYPES_NEW.HEMATOLOGY_RATIO,
    title: '胆红素/白蛋白比值',
    category: 'treatment/hematology',
    categoryName: '血液系统疾病',
    abbreviation: 'ratio',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/hematology?type=ratio',
    routerPath: '/tools/formula/treatment/hematology?type=ratio',
    miniPath: '/pages/tools/formula/treatment/hematology?type=ratio',
    description: '胆红素/白蛋白比值',
    formulaData: {
          "formula": "B/A = 总胆红素(μmol/L) / 白蛋白(g/L)",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "B/A：胆红素/白蛋白比值\n总胆红素：单位μmol/L\n白蛋白：单位g/L\nB/A正常：<5\nB/A>5：新生儿胆红素脑病高危\n新生儿黄疸评估，预测胆红素脑病风险。B/A比单纯胆红素水平更能预测脑病风险。",
          "reference": "",
          "description": ""
    }
  },
]

// 风湿免疫病科室公式 (treatment)
export const NEW_FORMULA_TOOLS_TREATMENT_RHEUMATOLOGY = [
  {
    toolType: TOOL_TYPES_NEW.RHEUMATOLOGY_BSBGJYJBZ,
    title: '白塞病国际研究标准',
    category: 'treatment/rheumatology',
    categoryName: '风湿性疾病',
    abbreviation: 'bsbgjyjbz',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/rheumatology?type=bsbgjyjbz',
    routerPath: '/tools/formula/treatment/rheumatology?type=bsbgjyjbz',
    miniPath: '/pages/tools/formula/treatment/rheumatology?type=bsbgjyjbz',
    description: '白塞病国际研究标准',
    formulaData: {
          "formula": "反复口腔溃疡 (必须) + 以下≥2项:\n1. 反复生殖器溃疡\n2. 眼部病变 (葡萄膜炎)\n3. 皮肤病变 (结节红斑/假性毛囊炎)\n4. 针刺反应阳性",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.RHEUMATOLOGY_RENAL,
    title: '狼疮性肾炎分型（ISN/RPS, 2003）',
    category: 'treatment/rheumatology',
    categoryName: '风湿性疾病',
    abbreviation: 'renal',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/rheumatology?type=renal',
    routerPath: '/tools/formula/treatment/rheumatology?type=renal',
    miniPath: '/pages/tools/formula/treatment/rheumatology?type=renal',
    description: '狼疮性肾炎分型（ISN/RPS, 2003）',
    formulaData: {
          "formula": "I: 轻微系膜性\nII: 系膜增生性\nIII: 局灶性\nIV: 弥漫性 (最重/最常见)\nV: 膜性\nVI: 硬化性",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "III、IV型需积极免疫抑制治疗",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.RHEUMATOLOGY_LFSGJYXXFLBZ,
    title: '类风湿关节炎X线分类标准',
    category: 'treatment/rheumatology',
    categoryName: '风湿性疾病',
    abbreviation: 'lfsgjyxxflbz',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/rheumatology?type=lfsgjyxxflbz',
    routerPath: '/tools/formula/treatment/rheumatology?type=lfsgjyxxflbz',
    miniPath: '/pages/tools/formula/treatment/rheumatology?type=lfsgjyxxflbz',
    description: '类风湿关节炎X线分类标准',
    formulaData: {
          "formula": "I期：无骨破坏\nII期：骨质疏松±软骨下骨轻度破坏\nIII期：骨侵蚀+关节畸形\nIV期：骨性强直",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.RHEUMATOLOGY_LFSGJYZDBZAC1987,
    title: '类风湿关节炎诊断标准（ACR, 1987）',
    category: 'treatment/rheumatology',
    categoryName: '风湿性疾病',
    abbreviation: 'lfsgjyzdbzac1987',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/rheumatology?type=lfsgjyzdbzac1987',
    routerPath: '/tools/formula/treatment/rheumatology?type=lfsgjyzdbzac1987',
    miniPath: '/pages/tools/formula/treatment/rheumatology?type=lfsgjyzdbzac1987',
    description: '类风湿关节炎诊断标准（ACR, 1987）',
    formulaData: {
          "formula": "1.晨僵≥1小时（≥6周）\n2.≥3个关节区肿胀（≥6周）\n3.腕、掌指、近端指间关节肿胀（≥6周）\n4.对称性关节肿胀（≥6周）\n5.手X线改变\n6.类风湿结节\n7.血清RF阳性",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "≥4项：RA诊断成立\n需除外其他关节炎",
          "reference": "",
          "description": ""
    }
  },
  {
    toolType: TOOL_TYPES_NEW.RHEUMATOLOGY_QZXJZYZDBZ,
    title: '强直性脊柱炎诊断标准',
    category: 'treatment/rheumatology',
    categoryName: '风湿性疾病',
    abbreviation: 'qzxjzyzdbz',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/rheumatology?type=qzxjzyzdbz',
    routerPath: '/tools/formula/treatment/rheumatology?type=qzxjzyzdbz',
    miniPath: '/pages/tools/formula/treatment/rheumatology?type=qzxjzyzdbz',
    description: '强直性脊柱炎诊断标准',
    formulaData: {
          "formula": "临床：腰背痛≥3月、活动受限、胸廓活动受限\nX线：骶髂关节炎（双侧≥II级或单侧III-IV级)\n确诊：X线+≥1临床标准",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "",
          "reference": "",
          "description": ""
    }
  },
]

// 骨科科室公式 (treatment)
export const NEW_FORMULA_TOOLS_TREATMENT_ORTHO = [
  {
    toolType: TOOL_TYPES_NEW.ORTHO_BADOMONTEGGIA,
    title: 'Bado分型（Monteggia骨折）',
    category: 'treatment/orthopedics',
    categoryName: '骨科',
    abbreviation: 'badomonteggia',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/orthopedics?type=badomonteggia',
    routerPath: '/tools/formula/treatment/orthopedics?type=badomonteggia',
    miniPath: '/pages/tools/formula/treatment/orthopedics?type=badomonteggia',
    description: 'Bado分型（Monteggia骨折）',
    formulaData: {
          "formula": "I型: 桡头向前脱 (最常见)\nII型: 桡头向后脱\nIII型: 桡头向外侧脱\nIV型: 双骨折 + 脱位",
          "parameters": "",
          "normalRange": "",
          "clinicalUse": "孟氏骨折分型",
          "reference": "",
          "description": ""
    }
  },
]

// 所有新增treatment公式
export const NEW_FORMULA_TOOLS_TREATMENT = [
  ...NEW_FORMULA_TOOLS_TREATMENT_GENERAL,
  ...NEW_FORMULA_TOOLS_TREATMENT_PEDIATRICS,
  ...NEW_FORMULA_TOOLS_TREATMENT_CARDIO,
  ...NEW_FORMULA_TOOLS_TREATMENT_DIABETES,
  ...NEW_FORMULA_TOOLS_TREATMENT_RESP,
  ...NEW_FORMULA_TOOLS_TREATMENT_NEUROLOGY,
  ...NEW_FORMULA_TOOLS_TREATMENT_GASTRO,
  ...NEW_FORMULA_TOOLS_TREATMENT_ONCOLOGY,
  ...NEW_FORMULA_TOOLS_TREATMENT_OBSTETRICS,
  ...NEW_FORMULA_TOOLS_TREATMENT_TRAUMA,
  ...NEW_FORMULA_TOOLS_TREATMENT_ANESTHESIOLOGY,
  ...NEW_FORMULA_TOOLS_TREATMENT_HEMATOLOGY,
  ...NEW_FORMULA_TOOLS_TREATMENT_RHEUMATOLOGY,
  ...NEW_FORMULA_TOOLS_TREATMENT_ORTHO,
]

// 兼容性导出
export const NEW_FORMULA_TOOLS = NEW_FORMULA_TOOLS_TREATMENT

// 辅助方法
export function getNewToolByType(toolType) {
  return NEW_FORMULA_TOOLS.find(tool => tool.toolType === toolType)
}

export function getToolPath(toolType) {
  const tool = getNewToolByType(toolType)
  return tool ? tool.link : ''
}

export default NEW_FORMULA_TOOLS
